<template>
	<div class="product-list">
		<div class="common-seach-wrap">
			<el-form size="small" :inline="true" :model="searchForm" class="demo-form-inline">
				<el-form-item label="昵称">
					<el-input size="small" v-model="searchForm.nickname" placeholder="请输入昵称"></el-input>
				</el-form-item>
				<el-form-item label="账号">
					<el-input size="small" v-model="searchForm.username" placeholder="请输入账号"></el-input>
				</el-form-item>

				<el-form-item>
					<el-button size="small" type="primary" icon="el-icon-search" @click="getData">查询</el-button>
				</el-form-item>
			</el-form>
		</div>
		<!--添加产品-->
		<div class="common-level-rail" style="display: flex">
			<el-button size="small" type="primary" @click="addClick" icon="el-icon-plus">添加渠道端用户</el-button>
		</div>
		<!--内容-->
		<div class="product-content">
			<div class="table-wrap">
				<el-table size="small" :data="tableData" border style="width: 100%">
					<!-- agent_code agent_qrcode agent_type avatarUrl balance channel_code channel_qrcode id mobile nickname type username -->
					<el-table-column prop="channelName" align="center" label="渠道名称" width="160">
					</el-table-column>
					<el-table-column prop="type" align="center" label="渠道类型" width="160">
						<template slot-scope="scope">
							<div>{{scope.row.type==1?'渠道':"业务员"}}</div>
						</template>
					</el-table-column>
					<el-table-column prop="username" align="center" label="账号" width="160"> </el-table-column>
					<el-table-column prop="nickname" align="center" label="昵称" width="160"> </el-table-column>
					<el-table-column prop="parent" align="center" label="上级业务员" width="160">
						<template slot-scope="scope">
							<!-- <div v-if="scope.row.parent">
              <div></div>
             </div> -->
							<div v-if="scope.row.parent">
								<div v-if="scope.row.parent==1">无上级</div>
								<div v-else>
									<div>上级ID:{{scope.row.parent.id}}</div>
									<div>上级名称:{{scope.row.parent.nickname}}</div>
									<div>渠道名称:{{scope.row.parent.channelName}}</div>
								</div>

							</div>
						</template>
					</el-table-column>
					<el-table-column prop="avatarUrl" align="center" label="头像" width="120">
						<template slot-scope="scope">
							<img :src="scope.row.avatarUrl" width="30" height="30" />
						</template>
					</el-table-column>

					<!-- <el-table-column prop="password" label="密码">
          </el-table-column> -->
					<el-table-column prop="mobile" align="center" label="手机号" width="120"> </el-table-column>

					<el-table-column prop="balance" align="center" label="余额" width="120">
						<template slot-scope="scope">
							<div style="color: red">￥{{ scope.row.balance }}</div>
						</template>
					</el-table-column>
					<el-table-column prop="channel_code" align="center" label="渠道邀请码" width="120"></el-table-column>
					<el-table-column prop="scale" align="center" label="分成比例" width="120"></el-table-column>

					<el-table-column fixed="right" align="center" label="操作" width="460">
						<template slot-scope="scope">
							<el-button @click="editClick(scope.row)" type="primary" size="small">编辑</el-button>
							<el-button @click="delClick(scope.row)" type="danger" size="small">删除</el-button>
							<el-button @click="toobserve(scope.row)" type="info" size="small">查看邀请码</el-button>
							<el-button @click="editpassword(scope.row)" type="warning" size="small">修改密码</el-button>
							<el-button v-if="scope.row.type==2&&scope.row.pid==0" @click="addxiaji(scope.row)"
								type="primary" size="small">添加下级</el-button>
						</template>
					</el-table-column>
				</el-table>
			</div>
		</div>
		<el-dialog title="邀请码" :visible.sync="showmytu" width="30%">
			<div style="width: 100px; height: 100px" class="mytu">
				<img :src="mycode" />
			</div>
			<span slot="footer" class="dialog-footer">
				<el-button @click="showmytu = false">取 消</el-button>
				<el-button type="primary" @click="showmytu = false">确 定</el-button>
			</span>
		</el-dialog>
		<el-dialog title="修改密码" :visible.sync="showpassword" width="30%">
			<div>
				<div>密码</div>

				<el-input v-model="password" placeholder="请输入新密码" class="max-w460" :type="flag1?'password':''">
					<template slot="append">
						<i slot="suffix" :class="[flag1 ? 'fa fa-eye-slash' : 'el-icon-view']" autocomplete="auto"
							@click="flag1 = !flag1" />
					</template>
				</el-input>
			</div>
			<span slot="footer" class="dialog-footer">
				<el-button @click="showpassword = false">取 消</el-button>
				<el-button type="primary" @click="confirmpassword">确 定</el-button>
			</span>
		</el-dialog>
		<div class="pagination">
			<el-pagination @size-change="handleSizeChange" @current-change="handleCurrentChange" background
				:current-page="curPage" :page-size="pageSize" layout="total, prev, pager, next, jumper"
				:total="totalDataNumber"></el-pagination>
		</div>
	</div>
</template>

<script>
	import ChannelApi from "@/api/channel.js";
	export default {
		components: {
			// Add
		},
		data() {
			return {
				tableData: [],
				open_add: false,
				/*一页多少条*/
				pageSize: 20,
				/*一共多少条数据*/
				totalDataNumber: 0,
				/*当前是第几页*/
				curPage: 1,
				searchForm: {
					type: "",
					nickname: "",
					username: "",
				},
				mycode: "",
				showmytu: false,
				showpassword: false,
				password: '',
				selectId: '',
				flag1: true,
			};
		},
		created() {
			/*获取列表*/
			this.getData();
		},
		methods: {
			/*选择第几页*/
			handleCurrentChange(val) {
				let self = this;
				self.loading = true;
				self.curPage = val;
				self.getData();
			},
			/*每页多少条*/
			handleSizeChange(val) {
				this.pageSize = val;
				this.getData();
			},
			/*打开添加*/
			addClick() {
				this.$router.push({
					path: "/channel/channel/add",
					query: {
						sence: "add",
					},
				});
			},
			confirmpassword() {
				let self = this;
				ChannelApi.changepassword({
					id: self.selectId,
					password: self.password
				}).then((data) => {
					self.$message({
						message: data.msg,
						type: "success",
					});
					self.showpassword = false

				});
			},
			toobserve(row) {
				let self = this;
				//  let a=""
				ChannelApi.obimg({
					id: row.id,
				}).then((data) => {
					console.log(data, data, 123);
					self.mycode = data.data;
					self.showmytu = true

				});
			},
			editpassword(row) {
				this.selectId = row.id
				this.showpassword = true
			},
			getData() {
				let self = this;
				let Params = self.searchForm;
				Params.pageIndex = self.curPage;
				Params.pageSize = self.pageSize;
				ChannelApi.ChannelUser(Params, true)
					.then((data) => {
						self.tableData = data.data.data;
						self.totalDataNumber = data.data.total;
					})
					.catch((error) => {
						// self.loading = false;
					});
			},
			/*打开编辑*/
			editClick(row) {
				this.$router.push({
					path: "/channel/channel/edit",
					query: {
						id: row.id,
						scene: "edit",
					},
				});
			},
			addxiaji(row) {
				this.$router.push({
					path: "/channel/channel/add",
					query: {
						id: row.id,
						scene: "addxiaji",
					},
				});

			},
			/*删除*/
			delClick: function(row) {
				let self = this;
				self
					.$confirm("确定删除该记录吗?", "提示", {
						type: "warning",
					})
					.then(() => {
						ChannelApi.channeldelete({
							id: row.id,
						}).then((data) => {
							self.$message({
								message: "删除成功",
								type: "success",
							});
							self.getData();
						});
					});
			},
		},
	};
</script>

<style scoped lang='scss'>
	.s_flex {
		display: flex;
		justify-content: space-between;
		text-align: center;
	}

	.mytu {
		img {
			width: 100px;
			height: 100px;
		}
	}
</style>


// WEBPACK FOOTER //
// src/views/channel/channel/index.vue